import { Model, belongsTo } from 'miragejs';

export default Model.extend({
  category: belongsTo('category', { inverse: null }),
  cmsCreatorId: belongsTo('user', { inverse: null }),
  cmsLockerId: belongsTo('user', { inverse: null }),
  cmsModifierId: belongsTo('user', { inverse: null }),
  cmsOwnerId: belongsTo('user', { inverse: null }),
  product: belongsTo('product', { inverse: 'customShops' }),
});
